import { Component, Input, OnInit } from '@angular/core';
import { SkeletonSizeBase } from '../../../common';

@Component({
  selector: 'skc-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.less']
})
export class MediaComponent extends SkeletonSizeBase implements OnInit {
  @Input('skc-show-media') showMedia = true;
  @Input('skc-show-play') showPlay = true;

  constructor() {
    super();
  }

  ngOnInit() {}
}
